import {Card, CardContent, CardMedia, Stack, Typography} from "@mui/material";
import {WorkClassDocument} from "../../../../types/pj1dbApiWork";
import {DEFAULT_IMAGE_BLACK_URL, LOADING_IMAGE_URL, pickImageByClass, pickImageUrl} from "../../../../utils/workUtil";
import {MODEL_BG_COLOR, WORK_ATTRS} from "../../../../constants/work";
import {FindModelResponse} from "../../../../types/pj1dbApiHandling";

export interface WorkListItemProps {
  work: WorkClassDocument;
  // eslint-disable-next-line react/require-default-props
  representativeModels?: FindModelResponse[];
  // eslint-disable-next-line react/require-default-props
  isLoading?: boolean;
}

export default function WorkClassListItem(props: WorkListItemProps) {
  const image = props.representativeModels
    ? pickImageByClass(props.work, props.representativeModels)
    : pickImageUrl(props.work);
  const showLoading = props.isLoading === true && image === DEFAULT_IMAGE_BLACK_URL;

  return (
    <Card sx={{p: 0, m: 0, width: 240, height: '100%'}}>
      <CardMedia
        component="img"
        height="145"
        image={showLoading ? LOADING_IMAGE_URL : image}
        alt={props.work.attr[WORK_ATTRS.nameJp.key]}
        sx={{objectFit: "scale-down", backgroundColor: MODEL_BG_COLOR}}
      />
      <CardContent sx={{pt: 1, px: 1, textWrap: 'nowrap', overflowX: 'scroll'}}>
        <Stack gap={1}>
          <Typography variant="subtitle2" component='p'>
            対象物名：<br/>
            {props.work.attr[WORK_ATTRS.nameJp.key]}
          </Typography>
          <Typography variant="subtitle2" component='p' sx={{color: "#888"}}>
            JANコード/部品コード：<br/>
            {props.work.attr[WORK_ATTRS.code.key]}
          </Typography>
        </Stack>
      </CardContent>
    </Card>
  )
}
